(() => {
  const widget = document.querySelector('[data-hf-whatsapp]');
  if (!widget || widget.dataset.ready) return;
  widget.dataset.ready = 'true';
  const trigger = widget.querySelector('summary');
  const closeButton = widget.querySelector('[data-hf-whatsapp-close]');
  const openLabel = trigger.getAttribute('aria-label');
  closeButton.hidden = false;
  function close(restoreFocus = false) {
    if (!widget.open) return;
    widget.open = false;
    if (restoreFocus) trigger.focus({preventScroll: true});
  }
  widget.addEventListener('toggle', () => {
    trigger.setAttribute('aria-expanded', String(widget.open));
    trigger.setAttribute('aria-label', widget.open ? closeButton.getAttribute('aria-label') : openLabel);
  });
  trigger.setAttribute('aria-expanded', String(widget.open));
  closeButton.addEventListener('click', () => close(true));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && widget.open) {
      event.preventDefault();
      close(true);
    }
  });
  document.addEventListener('click', event => {
    if (!widget.contains(event.target)) close();
  });
  // Keep the contact and back-to-top controls above actual bottom bars.
  const bars = [...document.querySelectorAll('.sticky-purchase, .compare-bar')];
  let frame = 0;
  let previous = -1;
  function updatePosition() {
    frame = 0;
    const blocked = document.querySelector('[data-hf-cookie-banner]:not([hidden]), .site-header[data-menu-open="true"], dialog[open]');
    if (blocked) close();
    let occupied = 0;
    for (const bar of bars) {
      const style = getComputedStyle(bar);
      if (bar.hidden || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) continue;
      if (bar.matches('.sticky-purchase') && !document.body.classList.contains('has-sticky-purchase')) continue;
      if (bar.matches('.compare-bar') && !document.body.classList.contains('has-compare')) continue;
      const rect = bar.getBoundingClientRect();
      if (rect.height > 0 && rect.top < innerHeight && rect.bottom > 0) occupied = Math.max(occupied, innerHeight - rect.top);
    }
    occupied = Math.ceil(occupied);
    if (occupied !== previous) {
      document.documentElement.style.setProperty('--hf-chat-obstruction', `${occupied}px`);
      previous = occupied;
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(updatePosition);
  }
  const resizeObserver = new ResizeObserver(schedule);
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {attributes: true, attributeFilter: ['class']});
  for (const element of [...bars, ...document.querySelectorAll('[data-hf-cookie-banner], .site-header, dialog')]) {
    observer.observe(element, {attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'data-menu-open']});
  }
  for (const bar of bars) {
    resizeObserver.observe(bar);
    bar.addEventListener('transitionend', schedule);
  }
  window.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  schedule();
})();
